import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { prepareHeaders } from '../../auth/entity/api/auth';

export interface Notifications {
  id: string;
  imgUrl: string;
  title: string;
  sentAt: string;
  description: string;
  link: string;
  linkDescription: string;
  altTitle?: string;
  media: {
    type: 'image' | 'video' | 'none';
    url: string;
  };
}

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders,
  }),

  endpoints: (builder) => ({
    getNotifications: builder.query<Notifications[], boolean>({
      query: (status) => ({
        url: apiRoutesV2.getNotifications(status),
        method: 'GET',
      }),
      transformResponse: (response, meta, arg): Notifications[] => {
        if (meta?.response?.status === 204) {
          return [];
        }
        return response as Notifications[];
      },
    }),
    readNotification: builder.mutation<void, string>({
      query: (id) => ({
        url: apiRoutesV2.readNotifications(id),
        method: 'PATCH',
      }),
      onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
        const patchUnread = dispatch(
          notificationsApi.util.updateQueryData('getNotifications', true, (draft) => {
            const index = draft.findIndex((notifications) => notifications.id === id);
            if (index !== -1) {
              const [notification] = draft.splice(index, 1);
              dispatch(
                notificationsApi.util.updateQueryData('getNotifications', false, (readDraft) => {
                  readDraft.push(notification);
                })
              );
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchUnread.undo();
        }
      },
    }),
  }),
});

export const { useGetNotificationsQuery, useReadNotificationMutation } = notificationsApi;
